const messages = {
  basicExport: 'Basic Export',
  excel: 'Excel',
  excludeTerms: 'Exclude "Terms & Conditions"',
  export: 'Export',
  exportFormat: 'Export format as',
  exportOrders: 'Export Orders',
  exportType: 'Export Type',
  failedExport: 'Your export failed to download',
  linesheetFormat: 'Linesheet Format',
  markExported: 'Mark orders as exported',
  mergeOrders: 'Merge orders into one file',
  pdf: 'PDF',
  selectOne: 'Select one',
  rawData: 'Raw Data',
  downloadCompleted: 'Your download is now being completed.',
  excludeImages: 'Exclude images',
  downloadOrderConfirmation: 'Download Order Confirmation',
  downloadFormat: 'Download selected as',
  downloadAll: 'Download all as',
  rawOrderData: 'Raw Order Data',
  download: 'Download',
}

export default messages
